module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-options"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "link-icon-after link-add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite = true
      }
    }
  }, [_vm._v("Add People To Chat")])]), _vm._v(" "), (_vm.$parent.members.length < 3) ? _c('div', _vm._l((_vm.$parent.members), function(member) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('single-member', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })) : _c('div', {
    staticClass: "group-chat-holder"
  }, _vm._l((_vm.$parent.members), function(member) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('multiple-members', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "admin-options"
  }, [_c('h5', [_vm._v("Options")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteChat($event)
      }
    }
  }, [_vm._v("Delete Chat")])]), _vm._v(" "), (_vm.invite) ? _c('invite', {
    attrs: {
      "chatID": _vm.chatID
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a1a0a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/conversation/Options.vue
// module id = 718
// module chunks = 1